import ENV from '../../ENV';

const COLORS = {
	PRIMARY: {
		name: 'primary',
		code: ENV.REACT_APP_PRIMARY_COLOR,
	},
	SECONDARY: {
		name: 'secondary',
		code: ENV.REACT_APP_SECONDARY_COLOR,
	},
	SUCCESS: {
		name: 'success',
		code: ENV.REACT_APP_SUCCESS_COLOR,
	},
	INFO: {
		name: 'info',
		code: ENV.REACT_APP_INFO_COLOR,
	},
	WARNING: {
		name: 'warning',
		code: ENV.REACT_APP_WARNING_COLOR,
	},
	DANGER: {
		name: 'danger',
		code: ENV.REACT_APP_DANGER_COLOR,
	},
	DARK: {
		name: 'dark',
		code: ENV.REACT_APP_DARK_COLOR,
	},
	LIGHT: {
		name: 'light',
		code: ENV.REACT_APP_LIGHT_COLOR,
	},
};

export function getColorNameWithIndex(index) {
	/*
	 * The size has been reduced by one so that the LIGHT color does not come out.
	 */
	return COLORS[Object.keys(COLORS)[index % (Object.keys(COLORS).length - 1)]].name;
}

export default COLORS;
